import { CompetitorItemDTO } from '../../dto';
import { CompetitorPrice } from './CompetitorPrice';

interface CompetitorItemProps {
  mgItemNumber: number;
  finfoNumber: number;
  nobbNumber: number;
  primaryText: string;
  mgSupplierItemId: number;
  storePrices: CompetitorPrice[];
}

export class CompetitorItem {
  mgItemNumber: number;
  finfoNumber: number;
  nobbNumber: number;
  primaryText: string;
  mgSupplierItemId: number;
  storePrices: CompetitorPrice[];

  constructor({
    mgItemNumber,
    finfoNumber,
    nobbNumber,
    primaryText,
    mgSupplierItemId,
    storePrices,
  }: CompetitorItemProps) {
    this.mgItemNumber = mgItemNumber;
    this.finfoNumber = finfoNumber;
    this.nobbNumber = nobbNumber;
    this.primaryText = primaryText;
    this.mgSupplierItemId = mgSupplierItemId;
    this.storePrices = storePrices;
  }

  static fromDto = (dto: CompetitorItemDTO): CompetitorItem =>
    new CompetitorItem({
      mgItemNumber: dto.mgItemNumber,
      finfoNumber: dto.finfoNumber,
      nobbNumber: dto.nobbNumber,
      primaryText: dto.primaryText,
      mgSupplierItemId: dto.mgSupplierItemId,
      storePrices: dto.storePrices ? dto.storePrices.map(CompetitorPrice.fromDto) : [],
    });
}
